import React from "react";
import "./HomeMeioAmbienteSection.css";
import ESGapproved from "../../imagens/logos/ESGaproved.jpeg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faTree } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const MeioAmbienteSection = () => {
  const { t, i18n } = useTranslation();

  const pdfLink =
    i18n.language === "en"
      ? "/pdfs/PoliticaAmbientalMGSEN.pdf"
      : "/pdfs/PoliticaAmbientalMGS.pdf";

  return (
    <section id="meioambiente-section" className="meioambiente-section p-5">
      <div className="d-flex align-items-center justify-content-center">

        <div className="row align-items-center justify-content-center">

          {/* Imagem */}
          <div className="col-lg-5 col-md-5 col-sm-6 text-center mb-3">
            <img
              src={ESGapproved}
              alt={t("homeMeioAmbiente.imageAlt")}
              className="meioambiente-img"
            />
          </div>

          {/* Texto */}
          <div className="col-lg-6 col-md-8 text-center">
            <h2 className="meioambiente-title mb-3">
              {t("homeMeioAmbiente.title")}
              <FontAwesomeIcon className="ps-3" icon={faTree} />
            </h2>

            <p className="meioambiente-text">
              {t("homeMeioAmbiente.description")}
            </p>

            <a
              href={pdfLink}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-pdf mt-3 d-inline-flex align-items-center gap-2"
            >
              <FontAwesomeIcon icon={faFilePdf} />
              {t("homeMeioAmbiente.button")}
            </a>
          </div>

        </div>
      </div>
    </section>
  );
};

export default MeioAmbienteSection;
